import { CLASS_DOT_COLORS } from '@/features/class/manage/constants';
import type { ManagedClass } from '@/features/class/manage/types';
import { MOCK_OWNED_CLASSES } from '@/features/profile/mockData';

function seedFromProfileMocks(): ManagedClass[] {
  return MOCK_OWNED_CLASSES.map((item, index) => ({
    id: item.id,
    code: item.code,
    name: item.name,
    classType: 'subject' as const,
    academicYearId: '2025-2026',
    academicYearLabel: '2025-2026',
    subjectId: 'mathematics',
    subjectLabel: 'Mathematics',
    gradeLevelId: '10',
    gradeLevelLabel: '10',
    credits: 3,
    isPrivate: item.isPrivate,
    archived: false,
    postCount: item.postCount,
    memberCount: item.memberCount,
    dotClassName: item.dotClassName ?? CLASS_DOT_COLORS[index % CLASS_DOT_COLORS.length],
  }));
}

export function seedManagedClasses(): ManagedClass[] {
  return seedFromProfileMocks();
}
